<script setup lang="ts">
import { NxtInput } from '@future-harry/nxt-styles';
import { JobBoard } from '@/core/collections/job-boards/job-board.interface';
import { useSettingsStore } from '@/apps/admin/stores/settings.store';

const jobBoard = defineModel<JobBoard>('modelValue', { required: true });
const settingsStore = useSettingsStore();
const jobBoardSettingsErrors = computed(() => settingsStore.validationErrors.value);
</script>

<template>
   <section>
      <div class="row">
         <div class="col-half">
            <NxtInput
               name="home_url"
               :label="$t('job-board.settings.url_home')"
               :errors="jobBoardSettingsErrors"
               :description="$t('job-board.settings.url_home_description')"
               v-model="jobBoard.home_url"
            />
         </div>
      </div>
   </section>
</template>
